<template>
  <v-dialog v-model="modalCreateChat" style="overflow-x: hidden; overflow-y: auto; height: 100%; ">
    <v-card style="max-width: 500px; border-radius: 20px">
      <v-card-title>
        {{ $t('Formulary.ChooseAContact') }}
      </v-card-title>
      <v-simple-table>
        <v-radio-group v-if="$user" v-model="selectedUser">
          <tbody style="padding: 0 24px;">
            <tr v-for="item in contacts" :key="item._id" style="padding:0;">
              <td> <v-radio :label="item.cif + '-' + item.name" :value="item._id" style="margin-left: 10px" @change="selectedUserInformation = item" /> </td>
            </tr>
          </tbody>
        </v-radio-group>
      </v-simple-table>

      <v-card-actions>
        <AddClient ref="addClient" @added="selectContact" />
       <v-btn class="elevation-0 btn-invite" style="border-radius: 10px" color="primary" @click="addContact"> <!-- afegir traducció-->
         {{$t('Formulary.AddContact')}}
        </v-btn>
        <v-spacer />
      </v-card-actions>
      <inviteChatForm v-if="selectedUserInformation != null" :prop-mail="selectedUserInformation.email" :prop-phone="selectedUserInformation.phone" @invite="sendMessage" />
    </v-card>
  </v-dialog>
</template>

<script>
import ApiRepository from "../repositories/ApiRepository";
import AddClient from "../components/AddClient";
import inviteChatForm from "../components/inviteChatForm";
import Constants from "../../constants";
export default {
    name: "ChooseContact",
    components: { AddClient, inviteChatForm },
    data: function () {
        return {
            contacts: [],
            modalCreateChat: false,
            selectedUser: "",
            selectedUserInformation: null,
            mode: Constants.CHAT_MODE.RIGHT
        };
    },
    created () {
        this.contacts = this.$user.contacts;
        this.fetch().then();
    },
    methods: {
        async fetch () {
            const res = await ApiRepository.getContacts(this.$user.cif);
            this.contacts = res.data.contacts;
            this.$nextTick(() => {
                if (this.contacts.length > 0) {
                    this.selectedUserInformation = this.contacts[0];
                    this.selectedUser = this.contacts[0]._id;
                }
            });
        },
        openModal (mode) {
            this.modalCreateChat = true;
            this.mode = mode;
        },
        closeModal () {
            this.modalCreateChat = false;
        },
        async selectContact (event) {
            await this.fetch();
            this.openModal();
            this.selectedUser = event.contactId;
            this.selectedUserInformation = event.contact;
        },
        sendMessage (event) {
            const inviteMethod = event.inviteMethod;
            const mail = event.mail;
            const phone = event.phone;

            let invitedUser = "";
            if (this.selectedUserInformation.name !== undefined) {
                invitedUser = this.selectedUserInformation.name;
            } else {
                invitedUser = this.selectedUserInformation.cif;
            }

            let user = "";
            if (this.$user.name !== undefined) {
                user = this.$user.name;
            } else {
                user = this.$user.cif;
            }

            ApiRepository.createChat(this.$user._id, this.mode)
                .then((res) => {
                    const today = new Date().getDate();
                    const thisMonth = new Date().getMonth() + 1;
                    const thisYear = new Date().getFullYear();
                    ApiRepository.inviteChat(res.data.chat._id, this.selectedUserInformation.cif, inviteMethod, mail).then((ret) => {
                        ApiRepository.sendMessage("0", res.data.chat._id, JSON.stringify({
                            message: 'chat.newDate',
                            params: {day: today, month: thisMonth, year: thisYear}
                        }), 'chat.newDate').then( () => {
                            console.log("//////CHOSE CONTACT INVITE /////////////");
                            ApiRepository.sendMessage("0", res.data.chat._id, JSON.stringify({message: 'chat.inviteDownStream', extraMessage: 'chat.inviteDownStreamExtra', params: {user: user, userInvited: invitedUser}}),  'chat.inviteDownStream');
                        });
                        const textMessage = this.extractContent(ret.data.messageHTML).replace(/\s{2,}/g, ' ').trim();
                        if (inviteMethod === Constants.INVITE_METHOD.WHATSAP) {
                            this.inviteChatWhatsap(encodeURIComponent(textMessage), phone);
                        } else if (inviteMethod === Constants.INVITE_METHOD.SMS) {
                            this.inviteChatSMS(textMessage, phone);
                        }
                        this.$router.push({ name: 'Chat',  query: {chatId: res.data.chat._id}});
                    }).catch(() => { });
                });
            this.closeModal();
        },
        addContact () {
            this.closeModal();
            this.$refs.addClient.openModal();
        },
        extractContent (s) {
            const span = document.createElement('span');
            span.innerHTML = s;
            return span.textContent || span.innerText;
        },
        getHrefAndroid (phone, message) {
            let messageToSend = message;
            const matches = message.match(/\bhttps?:\/\/\S+/);
            if (matches && matches[0]) {
                messageToSend = messageToSend.replace(matches[0].toString(), '');
                messageToSend = [messageToSend.slice(0, matches.index), encodeURIComponent(matches[0]), messageToSend.slice(matches.index)].join('');
            }
            return "sms:" + phone + "?body=" + encodeURIComponent(messageToSend);
        },
        getHrefiOS (phones, message) {
            let messageToSend = message;
            const matches = message.match(/\bhttps?:\/\/\S+/);
            if (matches && matches[0]) {
                messageToSend = messageToSend.replace(matches[0].toString(), '');
                messageToSend = [messageToSend.slice(0, matches.index), matches[0], messageToSend.slice(matches.index)].join('');
            }
            return "sms://open?addresses=" + phones + "/&body=" + encodeURIComponent(messageToSend);
        },
        isWin () {
            return (!this.isAndroid() && !this.isIOS());
        },
        isAndroid () {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            return /android/i.test(userAgent);
        },
        isIOS () {
            return [
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
            ].includes(navigator.platform)
              // iPad on iOS 13 detection
              || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
        },
        inviteChatWhatsap (message, phone) {
            // const message = Constants.BASE_URL + '/Chat?chatId=' + this.idChat + '&invoiceId=' + this.invoiceId + '&invite=1';
            // window.open("https://api.whatsapp.com/send?phone=+34" + phone + "&abid=+34677882757&text=" + message, '_blank');
            window.location.replace("https://api.whatsapp.com/send?phone=34" + phone + "&abid=34677882757&text=" + message);
        },
        inviteChatSMS (message, phone) {
            if (this.isAndroid())
                window.location.replace(this.getHrefAndroid(phone, message));
            else if (this.isIOS())
                window.location.replace(this.getHrefiOS(phone, message));
        },
    },
};
</script>

<style scoped>
.btn-invite{
    margin: 0 10px 10px 13px;
}
.avatar-icon {
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 4;
  color: #ffffff;
  font-weight: bold;
  border-radius: 50%;
}
</style>
